module.exports = __webpack_public_path__ + "img/sablierrouge_off.e077b954.gif";